import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../../components/elements/Loader'
import EmptyState from '../../../../components/elements/EmptyState'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import NewScholarship from '../../../../components/partials/scholarships/NewScholarship'
import Pagination from '../../../../components/elements/Pagination'
import ScholarshipCard from '../../../../components/partials/scholarships/ScholarshipCard'
import { clearCreatedScholarship, fetchScholarships } from '../../../../store/actions/scholarshipsActions'

const Scholarships = () => {
    const dispatch = useDispatch()
    const scholarshipsSelector = useSelector(state => state.scholarships)
    const [creatingScholarship, setCreatingScholarship] = useState(false)

    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(25)

    useEffect(() => {
        dispatch(fetchScholarships(``, page, perPage))

        if(scholarshipsSelector.createdScholarship !== null) {
            dispatch(clearCreatedScholarship())
            setCreatingScholarship(false)
        }
        
        return () => {
            
        }
    }, [dispatch, page, perPage, scholarshipsSelector.createdScholarship])
    
    
    return (
        <>
            <AdministrationLayout>
                <div className='w-full'>
                    <div className='w-full flex justify-between'>
                        <div className='w-9/12'>
                            <h3 className='text-lg font-medium'>Vaatia College Scholarships</h3>
                            <p className='text-sm'>Scholarships iin vaatia college are displayed below. Click on the "Create Scholarship" button to create a new scholarship or click on one of the scholarships below to view details, edit scholarship, or offer scholarships to students.</p>
                        </div>
                        
                        <div>
                            <button onClick={()=>{setCreatingScholarship(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                            <PlusIcon className='w-5 h-5' /> Create Scholarship
                            </button>
                        </div>
                    </div>

                    {scholarshipsSelector.loadingScholarships
                    ? 
                        <Loader /> 
                    :
                        scholarshipsSelector?.scholarships?.scholarships?.length > 0 ? <>
                            <div className='w-full grid grid-cols-4 gap-[10px] mt-[50px]'>
                                {scholarshipsSelector?.scholarships?.scholarships?.map((scholarship, scholarshipIndex) => (
                                    <div key={scholarshipIndex} className='w-full'>
                                        <ScholarshipCard 
                                            scholarship={scholarship} 
                                        />
                                    </div>
                                ))}
                            </div>

                            <Pagination 
                                pagination={{
                                    perPage, 
                                    page,
                                    totalItems: scholarshipsSelector?.scholarships?.total,
                                }} 
                                changePage={setPage} 
                                updatePerPage={setPerPage}
                            />
                        </>
                        : 
                        <div className='mt-12'>
                            <EmptyState
                                emptyStateText={`No scholarships created yet. Please create some by clicking the "Create Scholarship" button above`}
                            />
                        </div>
                    }
                </div>
            </AdministrationLayout>

            <ModalDialog
                shown={creatingScholarship} 
                closeFunction={()=>{setCreatingScholarship(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Create a new Scholarship'
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <NewScholarship close={()=>{setCreatingScholarship(false)}} />
            </ModalDialog>
        </>
  )
}

export default Scholarships